// App.js
import React, { Suspense, lazy } from 'react';
import { Route, Routes } from 'react-router-dom';
import './App.css';
import MainLayout from './layouts/MainLayout';
import { AuthProvider } from './features/auth/AuthContext';
import ProtectedRoute from './ProtectedRoute';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
import Loader from './components/feedback/Loader';

// Lazy load feature components
const Home = lazy(() => import('./features/home/Home'));
const PageNotFound = lazy(() => import('./features/home/PageNotFound'));
const CommitteeMembers = lazy(() => import('./features/members/CommitteeMembers'));
const About = lazy(() => import('./features/home/About'));
const Contact = lazy(() => import('./features/contact/Contact'));
const Activities = lazy(() => import('./features/home/Activities'));
const Login = lazy(() => import('./features/auth/Login'));
const ForgotPassword = lazy(() => import('./features/auth/ForgotPassword'));
const Register = lazy(() => import('./features/auth/Register'));
const RegistrationForm = lazy(() => import('./features/auth/RegistrationForm'));
const PaymentPage = lazy(() => import('./features/auth/PaymentPage'));
const ConfirmationPage = lazy(() => import('./features/auth/ConfirmationPage'));
const CMERequestForm = lazy(() => import('./features/cme/CMERegistration'));
const UserWaitPage = lazy(() => import('./features/cme/UserWaitPage'));
const CMEPaymentPage = lazy(() => import('./features/cme/CMEPaymentPage'));
const PaymentSuccess = lazy(() => import('./features/cme/PaymentSuccess'));
const GpconPage = lazy(() => import('./features/gpcon/GpconPage'));
const GpconRegForm = lazy(() => import('./features/gpcon/GpconRegForm'));
const RegistrationSuccess = lazy(() => import('./features/gpcon/RegistrationSuccess'));
const UserProfile = lazy(() => import('./features/auth/UserProfile'));

function App() {
  return (
    <AuthProvider>
      <ScrollToTop />
      <Suspense fallback={<Loader />}>
        <Routes>
          <Route element={<MainLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="*" element={<PageNotFound />} />
            <Route path="/CommitteeMembers" element={<CommitteeMembers />} />
            <Route path="/About" element={<About />} />
            <Route path="/Contact" element={<Contact />} />
            <Route path="/activities/2019" element={<Activities />} />
            <Route path="/Login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/Register" element={<Register />} /> 
            <Route path="/RegistrationForm" element={<RegistrationForm />} />
            <Route path="/payment" element={<PaymentPage />} />
            <Route path="/confirmation" element={<ConfirmationPage />} />
            <Route path="/CMERequest" element={<CMERequestForm />} />
            <Route path="/Request/:id" element={<UserWaitPage />} />
            <Route path="/Checkout" element={<CMEPaymentPage />} />
            <Route path="/PaymentSuccess" element={<PaymentSuccess />} />
            <Route path="/gpcon2025" element={<GpconPage />} />
            <Route path="/Registration-form" element={<GpconRegForm />} />
            <Route path="/registration-success" element={<RegistrationSuccess />} />
            {/* Protected Routes */}
            <Route
              path="/profile"
              element={
                <ProtectedRoute>
                  <UserProfile />
                </ProtectedRoute>
              }
            />
          </Route>
        </Routes>
      </Suspense>
    </AuthProvider>
  );
}

export default App;

